import * as coronaNumbers from './corona-numbers';
import * as coronaStatistics from './corona-statistics';
import * as vaccineProgress from './vaccine-progress';

export const init = () => {
  if (document.querySelector('[data-corona-number]') || document.querySelector('.coronaStatistics')) {
    coronaNumbers.init();
    coronaStatistics.init();
  }

  if (document.querySelector('.js-vaccineProgress')) {
    vaccineProgress.init();
  }
};
